<template>
  <div>
    <a-modal width="1036px"
             title="资源使用情况"
             v-model="visibleModal"
             @cancel="close">
      <div class="usage-layout">
        <div class="usage-left-layout">
          <ul>
            <li :class="[
                'space-item',
                { active: paramsObj.spaceId == item.spaceId },
              ]"
                v-for="(item, index) in spaceList"
                :key="index"
                @click="onChangeSpace(item)">
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div v-if="spaceList.length > 0"
             class="usage-right-layout">
          <div class="usage-filter-row">
            <a-date-picker style="width: 200px"
                           valueFormat="YYYY-MM-DD"
                           :default-value="paramsObj.startDate"
                           @change="onChangeDate"
                           :allowClear="false"
                           :inputReadOnly="true" />
            <a-radio-group v-if="userInfo.userType != 4 && userInfo.userType != 6"
                           v-model="paramsObj.type"
                           size="small"
                           @change="getUsageList">
              <a-radio-button value="1"> 自留资源 </a-radio-button>
              <a-radio-button value="2"> 平台资源 </a-radio-button>
            </a-radio-group>
          </div>
          <a-alert showIcon
                   type="info"
                   class="usage-info-box">
            <template>
              <div slot="message"
                   class="usage-info-content">
                {{ paramsObj.startDate }}共&nbsp;<span class="usage-box-num">{{
                  total
                }}</span>&nbsp;个订单<template v-if="paramsObj.spaceId == 1">，{{
                    paramsObj.type == 1 ? "自留资源" : "平台资源"
                  }}使用了&nbsp;
                  <span class="usage-box-num">{{ usageRate }}</span>
                </template>
              </div>
            </template>
          </a-alert>
          <a-table :columns="columns"
                   :dataSource="tableData"
                   :pagination="false"
                   :scroll="{ x: 640, y: 330 }"
                   :loading="loading">
            <span slot="planName"
                  slot-scope="row"
                  style="color: #1890ff; cursor: default"
                  @click="routeOrderDetail(row)">{{ row.planName || "" }}</span>
            <span slot="operate"
                  slot-scope="row"
                  style="color: #1890ff; cursor: pointer"
                  @click="operate(row)">
              查看素材
            </span>
          </a-table>
          <div class="page-wrap">
            <a-pagination :pageSizeOptions="pageSizeOptions"
                          :total="total"
                          showSizeChanger
                          showQuickJumper
                          :pageSize="paramsObj.pageSize"
                          v-model="paramsObj.pageNum"
                          @showSizeChange="onShowSizeChange"
                          @change="changePage">
            </a-pagination>
          </div>
        </div>
      </div>
      <div class="page-wrap"></div>
      <template slot="footer">
        <a-button @click="close">关闭</a-button>
      </template>
    </a-modal>
    <!--查看大图-->
    <!-- <a-modal
      v-model="previewImgModal"
      :footer="null"
      :zIndex="1002"
      :closable="false"
      :bodyStyle="{ padding: 0, margin: 0, background: 'rgba(0, 0, 0, 0)' }"
      width="390px"
      class="preview-img"
    >
      <div class="img-box">
        <img :src="previewUrl" alt />
      </div>
    </a-modal> -->
    <!--查看视频-->
    <!-- <a-modal
      v-model="previewVideoModal"
      @cancel="handleCancel"
      :footer="null"
      :closable="false"
      :bodyStyle="{ padding: 0, margin: 0, background: 'rgba(0, 0, 0, 0)' }"
      :zIndex="1002"
      width="370px"
      class="preview-video"
    >
      <div class="video-box">
        <video
          ref="showMaterialVideo"
          :src="previewUrl"
          controls
          autoplay="autoplay"
          loop="loop"
        ></video>
      </div>
    </a-modal> -->
    <a-modal title="查看物料"
             v-model="uploadMaterialModal"
             :footer="null"
             width="977px"
             destroyOnClose>
      <div class="material_warp">
        <material-frames :isEdit="false"
                         :isDuration="materialData.isDuration"
                         :beginTime="materialData.beginTime"
                         :endTime="materialData.endTime"
                         :planId="materialData.planId"
                         :materialSize="materialData.materialSize" />
      </div>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import api from '../../../commomFun/api.js'
import materialFrames from '../../channelAd/materialFrames/index.vue' //查看物料组件
import { mapActions } from 'vuex'

export default {
  components: {
    materialFrames,
  },
  name: 'PreBroadcast',
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    requestParams: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      visibleModal: false,
      loading: false,
      spaceList: [],
      columns: [
        {
          title: '渠道方',
          key: 'channelName',
          dataIndex: 'channelName',
          width: 130,
          ellipsis: true,
        },
        {
          title: '订单名称',
          key: 'planName',
          width: 160,
          ellipsis: true,
          scopedSlots: { customRender: 'planName' },
        },
        {
          title: '投放日期区间',
          width: 160,
          ellipsis: true,
          customRender: (text, record) => {
            return `${record.beginDate}~${record.endDate}`
          },
        },
        {
          title: '广告时长',
          key: 'playDuration',
          dataIndex: 'playDuration',
          width: 120,
          ellipsis: true,
          customRender: (text, record) => {
            return `${text}秒`
          },
        },
        {
          title: '播放次数',
          key: 'playCount',
          dataIndex: 'playCount',
          ellipsis: true,
          width: 120,
        },
        {
          title: '操作',
          key: 'operate',
          width: 90,
          fixed: 'right',
          scopedSlots: { customRender: 'operate' },
        },
      ],
      tableData: [],
      // 查看物料
      previewImgModal: false,
      previewUrl: '',
      previewVideoModal: false,
      // 表格分页数据
      pageSizeOptions: ['10', '20', '30', '40'],
      total: 0,
      usageRate: '0%',
      paramsObj: {
        // 资源使用情况日期
        startDate: moment(new Date()).format('YYYY-MM-DD'),
        // 资源归属（自留or平台）1 为自留，2总部
        type: '1',
        // 当前选中广告位
        spaceId: '',
        pageNum: 1,
        pageSize: 10,
      },
      userInfo: {},
      uploadMaterialModal: false, //查看物料弹窗
      materialData: {}, //物料信息
    }
  },
  computed: {},
  watch: {
    visible(val) {
      this.visibleModal = val
      if (val) {
        this.getAdSpaceByPointId().then(
          (flag) => flag > 0 && this.getUsageList()
        )
      }
    },
  },
  mounted() {
    this.userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
  },
  methods: {
    ...mapActions(['getMaterialList']),
    close() {
      this.$emit('close')
    },
    // 查看订单详情
    routeOrderDetail(row) {
      if (!row.planId) {
        this.$message.warn('计划id获取失败！')
        return
      }
      sessionStorage.setItem('planId', row.planId)
      const { href } = this.$router.resolve({
        path: '/channelAdPlanDetail',
      })
      window.open(href, '_blank')
    },
    async operate(row) {
      //预览大图/视频
      let { data, code } = await this.getMaterialList(row.planId)
      data = data[0]
      if (data && code == 200) {
        this.materialData = {
          isDuration: data.playDuration,
          beginTime: data.beginTime,
          endTime: data.endTime,
          planId: data.planId,
          materialSize: {
            w: 1080,
            h: 1540,
          }, //查看不能编辑随便传个尺寸
        }
        this.uploadMaterialModal = true
      } else {
        this.$message.warning(res.data.msg || '素材获取异常')
      }

      // if (!row.url) {
      //   this.$message.warn("暂无物料！");
      //   return;
      // } else {
      //   this.previewUrl = row.url;
      // }
      // // fileType文件类型 1图片海报 2声音 3视频
      // if (row.fileType == 1) {
      //   this.previewImgModal = true;
      // } else if (row.fileType == 3) {
      //   this.previewVideoModal = true;
      //   let timer = setTimeout(() => {
      //     let video = this.$refs.showMaterialVideo;
      //     video.play();
      //     clearTimeout(timer);
      //   }, 200);
      // }
    },
    onChangeSpace(item) {
      this.paramsObj.spaceId = item.spaceId
      this.getUsageList()
    },
    onChangeDate(date, dateString) {
      this.paramsObj.startDate = dateString
      this.getUsageList()
    },
    handleCancel() {
      this.previewVideoModal = false
      this.$refs.showMaterialVideo.pause()
    },
    // 获取该点位广告位
    getAdSpaceByPointId() {
      this.spaceList = []
      return new Promise((resolve, reject) => {
        api
          .getApi('/adSpace/listAdSpaceByPointId', {
            ...this.requestParams,
          })
          .then((res) => {
            console.log(res.data.data, '这个接口多加三种类型')
            if (res.data.code == 200 && res.data.data.length > 0) {
              this.spaceList = res.data.data || []
              this.paramsObj.spaceId = this.spaceList[0].spaceId
              this.paramsObj.startDate = moment(new Date()).format('YYYY-MM-DD')
              this.paramsObj.type = '1'
              resolve(this.spaceList.length)
            } else {
              this.$message.error(res.data.msg)
            }
          })
      })
    },
    // 获取资源使用情况列表
    getUsageList() {
      this.loading = true
      this.getUsageRate()
      api
        .getApiSpecil('/platform/pointResource/list', {
          ...this.requestParams,
          ...this.paramsObj,
        })
        .then((res) => {
          if (res.data.code == 200 && res.data.data) {
            this.tableData = res.data.data.list || []
            this.tableData.forEach((item, index) => {
              item.key = index
            })
            this.total = res.data.data.total
          } else {
            this.$message.error(res.data.msg)
          }
        })
        .finally((_) => {
          this.loading = false
        })
    },
    // 获取资源占比
    getUsageRate() {
      console.log(';;;;')
      let params = {
        ...this.requestParams,
        ...this.paramsObj,
      }
      // delete params.startDate;
      delete params.pageSize
      delete params.pageNum
      api
        .getApiSpecil('/platform/pointResource/getPointResourceCount', params)
        .then((res) => {
          if (res.data.code == 200) {
            res.data.data &&
              (this.usageRate =
                ((res.data.data.rate || 0) * 100).toFixed(2) + '%')
          } else {
            this.$message.error(res.data.msg)
          }
        })
    },
    changePage(page, pageSize) {
      this.paramsObj.pageSize = pageSize
      this.paramsObj.pageNum = page
      this.getUsageList()
    },
    onShowSizeChange(current, pageSize) {
      this.paramsObj.pageSize = pageSize
      this.getUsageList()
    },
  },
}
</script>

<style lang="scss" scoped>
.usage-info-box {
  margin: 0 0 16px;
  .usage-info-content {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 20px;
    color: rgba(0, 0, 0, 0.65);
    .usage-box-num {
      color: #1890ff;
    }
    .usage-box-btn {
      margin: 0 0 0 auto;
      color: #1890ff;
    }
  }
}
.usage-layout {
  display: flex;
  align-items: flex-start;
  flex-flow: row nowrap;
  height: 522px;
  box-sizing: border-box;
  border: 1px solid #e9e9e9;
  .usage-left-layout {
    width: 288px;
    height: 100%;
    padding: 8px;
    box-sizing: border-box;
    border-right: 1px solid #e9e9e9;
    .space-item {
      width: 100%;
      height: 48px;
      line-height: 48px;
      border-radius: 4px;
      text-indent: 12px;
      cursor: default;
      &.active {
        background: rgba(0, 0, 0, 0.05);
      }
    }
  }
  .usage-right-layout {
    width: 700px;
    padding: 24px;
    .usage-filter-row {
      display: flex;
      flex-flow: row nowrap;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 16px;
    }
  }
}
.preview-img /deep/ .ant-modal-content,
.preview-video /deep/ .ant-modal-content {
  background: rgba(0, 0, 0, 0);
  box-shadow: unset;
}
.img-box,
.video-box {
  text-align: center;
}

.img-box img {
  max-width: 100%;
  height: 600px;
  object-fit: contain;
}

.video-box video {
  max-width: 100%;
  height: 600px;
}

.page-wrap {
  float: unset;
  text-align: right;
}
</style>
